import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDoc, doc, getDocs, collection } from "firebase/firestore";
import { database } from "../../firebase";
import { serializeFirebaseData } from "../../utils/serializeFirebaseData";

const collectionName = "orders";

export const fetchAllOrders = createAsyncThunk(
  "order/fetchAllOrders",
  async (_, thunkAPI) => {
    try {
      const querySnapshot = await getDocs(collection(database, collectionName));
      const orders = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...serializeFirebaseData(doc.data()),
      }));
      return orders;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const fetchOrder = createAsyncThunk(
  "order/fetchOrder",
  async (orderId, thunkAPI) => {
    try {
      const docRef = doc(database, collectionName, orderId);
      const snapshot = await getDoc(docRef);
      if (snapshot.exists()) {
        return { 
          id: snapshot.id, 
          ...serializeFirebaseData(snapshot.data()) 
        };
      } else {
        throw new Error("Order not found");
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
